import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { UniqueValidatorFn } from '../directives/unique-validator.directive';

export type ConditionalFn = (control: AbstractControl) => boolean;

@Injectable({
  providedIn: 'root'
})
export class CustomValidationService {
  static conditionalValidator = (condition: ConditionalFn, validators: ValidatorFn | ValidatorFn[]): ValidatorFn =>
    control => {
      if (!condition(control)) {
        return null;
      }

      if (!Array.isArray(validators)) {
        return validators(control);
      }

      return validators
        .map(v => v(control))
        .reduce((errors, result) => result === null ? errors : (Object.assign(errors || {}, result)));
    };

  static uniqueValidator = (fn: UniqueValidatorFn): AsyncValidatorFn =>
    control => fn
      ? fn(control.value).then(result => result ? null : { unique: true })
      : null;

    static regexValidator = (regex: RegExp, errorKey: string = 'pattern'): ValidatorFn =>
      (control: AbstractControl) => {
        if (!control.value || regex.test(control.value)) {
          return null; // Valid if the value matches the regex or is empty
        }
        return { [errorKey]: true }; // Return an error object if the value doesn't match
      };
}
